import { render, staticRenderFns } from "./EscolaBiblica.vue?vue&type=template&id=c3bc6b1a&scoped=true"
import script from "./EscolaBiblica.vue?vue&type=script&lang=js"
export * from "./EscolaBiblica.vue?vue&type=script&lang=js"
import style0 from "./EscolaBiblica.vue?vue&type=style&index=0&id=c3bc6b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bc6b1a",
  null
  
)

export default component.exports